import { useSelector, useDispatch } from 'react-redux';
import { loadIndexAutomix, setPlaylistAutomix } from "../redux/actions/index";

const useAutomixLoad = (id, enabled = true) => {
  const dispatch = useDispatch();
  const playlistAutomix = useSelector(state => (!!state.uidAutomix) ? state.playlistAutomix : null);
  const isCurrentPlayAutomix = useSelector(state => state.isCurrentPlayAutomix);
  let loadToAutomix = null;
  let isPlaying = false;
  let stackAutomix = useSelector(state => state.stackAutomix);
  
  if (playlistAutomix && playlistAutomix.tracks) {
    let indexTrack = playlistAutomix.tracks.findIndex( (x) => x.id === id );
    isPlaying = (indexTrack >= 0 && indexTrack === playlistAutomix.active);
    loadToAutomix = (indexTrack >= 0 && enabled) ? () => { 
      dispatch(loadIndexAutomix(indexTrack));
      setTimeout(() => { window['YouDJ'] && window['YouDJ'].automix_next(); }, 100)
    } : false

    // LOAD FROM OUTSIDE
    stackAutomix = Array.isArray(stackAutomix) ? stackAutomix[stackAutomix.length - 1] : stackAutomix

    if (stackAutomix && stackAutomix.tracks && indexTrack < 0) {
      let indexTrackFromStack = stackAutomix.tracks.findIndex( (x) => x.id === id );
      loadToAutomix = (indexTrackFromStack >= 0 && enabled) ? () => {
        dispatch(setPlaylistAutomix({ ...playlistAutomix, tracks: playlistAutomix.tracks.toSpliced(playlistAutomix.active + 1, 0, stackAutomix.tracks[indexTrackFromStack]) }));
        dispatch(loadIndexAutomix(playlistAutomix.active + 1));
        setTimeout(() => { window['YouDJ'] && window['YouDJ'].automix_next(); }, 100)
      } : false;
    }
  }
  
  const playpause = () => {
    window['YouDJ'] && window['YouDJ'].automix_playpause();
  }

  return { loadToAutomix, playpause, isPlaying, isCurrentPlayAutomix };
}

export default useAutomixLoad;
